import { render } from "./DrawerTrigger.vue?vue&type=template&id=45b02377&scoped=true"
import script from "./DrawerTrigger.vue?vue&type=script&lang=js"
export * from "./DrawerTrigger.vue?vue&type=script&lang=js"

import "./DrawerTrigger.vue?vue&type=style&index=0&id=45b02377&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b02377"]])

export default __exports__